'use client'

import { MouseEvent, PropsWithChildren } from 'react'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { clickEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { ROOT_URL } from 'constants/routes'

import { navigateToPage } from '@marketplace-web/shared/browser'

import {
  handleDismissVerificationPrompt,
  trackEmailCodeSkipEvent,
} from './client-email-code-test-handlers'

type Props = {
  ariaLabel: string
  userId: number | null
}

const ClientHeaderLogoAction = ({ children, ariaLabel, userId }: PropsWithChildren<Props>) => {
  const { track } = useTracking()

  const handleDismissPrompt = async () => {
    if (!userId) return
    await handleDismissVerificationPrompt({ userId })
    navigateToPage(ROOT_URL)
  }

  const handleLogoClick = (event: MouseEvent) => {
    const trackingEvent = clickEvent({
      target: ClickableElement.Logo,
    })
    track(trackingEvent)

    event.preventDefault()
    if (!userId) return

    trackEmailCodeSkipEvent({ track, userId })
    handleDismissPrompt()
  }

  return (
    <div className="l-header__logo">
      <a
        className="u-block"
        href={ROOT_URL}
        title={ariaLabel}
        aria-label={ariaLabel}
        onClick={handleLogoClick}
        data-testid="header-logo-id"
      >
        {children}
      </a>
    </div>
  )
}

export default ClientHeaderLogoAction
